import { render, staticRenderFns } from "./DiscountItem.vue?vue&type=template&id=0e1fd120&scoped=true&"
import script from "./DiscountItem.vue?vue&type=script&lang=js&"
export * from "./DiscountItem.vue?vue&type=script&lang=js&"
import style0 from "./DiscountItem.vue?vue&type=style&index=0&id=0e1fd120&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1fd120",
  null
  
)

export default component.exports